<script setup lang="ts">
import { ref } from 'vue'

const activeTab = ref<'essential' | 'enhanced' | 'premium'>('essential')

const emit = defineEmits<{
  'tab-change': [tab: 'essential' | 'enhanced' | 'premium']
}>()

function handleTabClick(tab: 'essential' | 'enhanced' | 'premium'): void {
  activeTab.value = tab
  emit('tab-change', tab)
}
</script>

<template>
  <div class="templates-container">
    <h1 class="page-title">Care Templates</h1>

    <div class="tabs-section">
      <div class="tabs-wrapper">
        <button
          class="tab-button"
          :class="{ active: activeTab === 'essential' }"
          @click="handleTabClick('essential')"
        >
          Essential Care
        </button>
        <button
          class="tab-button"
          :class="{ active: activeTab === 'enhanced' }"
          @click="handleTabClick('enhanced')"
        >
          Enhanced Care
        </button>
        <button
          class="tab-button"
          :class="{ active: activeTab === 'premium' }"
          @click="handleTabClick('premium')"
        >
          Premium Care
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.templates-container {
  width: 100%;
  padding: 0;
  box-sizing: border-box;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  font-family:
    SFPro,
    'SF Pro',
    -apple-system,
    BlinkMacSystemFont,
    system-ui,
    sans-serif;
  color: #000000;
  margin-top: -10px;
  margin-left: -9px;
}

.tabs-section {
  margin-top: 18px;
  margin-left: -9px;
  margin-bottom: 15px;
}

.tabs-wrapper {
  display: inline-flex;
  background-color: #FFFFFF;
  border-radius: 16px;

}

.tab-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family:
    SFPro,
    'SF Pro',
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    system-ui,
    sans-serif;
  width: 164px;
  height: 34px;
  padding: 0;
  border: none;
  background-color: transparent;
  color: #999999;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  border-radius: 16px;
  cursor: pointer;
  white-space: nowrap;
}

.tab-button.active {
  background-color: #000000;
  color: #fff;
  border-radius: 16px;
  height: 34px;
}
</style>
